import { Awesome } from '../icons/Awesome/Awesome';
import { Good } from '../icons/Good/Good';
import { Okay } from '../icons/Okay/Okay';
import { Sad } from '../icons/Sad/Sad';
import { Terrible } from '../icons/Terrible/Terrible';

export const transformMood = (mood, color) => {
  switch (mood) {
    case 1:
      return <Terrible color={color} />;
    case 2:
      return <Sad color={color} />;
    case 3:
      return <Okay color={color} />;
    case 4:
      return <Good color={color} />;
    case 5:
      return <Awesome color={color} />;
  }
};
